import axios from 'axios'
import VUE_APP_API_HERA_URL from './getapi/hera'

let apiURL = ''
// console.log(process.env.NODE_ENV)
if (process.env.NODE_ENV === "development") {
	// alert("开发环境");
	// apiURL = 'https://hera.haiweikexin.com/api/v1'
	apiURL = 'http://proxy.jiankanghao.net:50244/api/v1'
} else {
	// alert("生产环境");
	apiURL = VUE_APP_API_HERA_URL
}

let http = axios.create({
	timeout: 12000,
	baseURL: apiURL,
	//baseURL: 'http://192.168.0.31:9501/api/v1/',
	headers: {
		'Content-Type': 'application/json;charset=UTF-8;'
	}
});
export default http;



// WEBPACK FOOTER //
// ./src/util/heraApiConfig.js